// import React, { useRef, useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
// import data from "../ApiUrl/meta_api.js";
// import "../../assets/css/Internship.css";   // ← புதிய Internship.css

// import { IoIosArrowForward } from "react-icons/io";
// import { BiSolidChevronsRight } from "react-icons/bi";

// // ─── Scroll Reveal Hook ─────────────────────────────────
// function useScrollReveal(ref) {
//   useEffect(() => {
//     const el = ref.current;
//     if (!el) return;
//     el.style.opacity = '0';
//     el.style.transform = 'translateY(40px)';

//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           el.style.transition = 'all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
//           el.style.opacity = '1';
//           el.style.transform = 'translateY(0)';
//           observer.disconnect();
//         }
//       },
//       { threshold: 0.15 }
//     );
//     observer.observe(el);
//     return () => observer.disconnect();
//   }, []);
// }

// function Internship() {
//   const [meta, setMeta] = useState(null);

//   const heroRef = useRef(null);
//   const automationRef = useRef(null);
//   const digitalRef = useRef(null);

//   useEffect(() => {
//     const internshipMeta = data[0]?.Internship_page;
//     if (internshipMeta) setMeta(internshipMeta);
//   }, []);

//   useScrollReveal(heroRef);
//   useScrollReveal(automationRef);
//   useScrollReveal(digitalRef);



//   return (
//     <>
//       <Helmet>
//         <title>{meta ? meta.title : "Internship Programs in Salem | Skimitar Hindusthan"}</title>
//         <meta name="description" content="Gain real industry experience with our Industrial Automation and Digital Marketing Internship programs in Salem." />
//         <link rel="canonical" href="https://skimitaracademy.com/internship" />
//       </Helmet>

//       {/* HERO */}
//       <section className="int-hero position-relative overflow-hidden" ref={heroRef}>
//         <div
//           className="int-hero-bg position-absolute w-100 h-100"
//           style={{
//             backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.75)), url(${require("../../assets/images/Internship/Internship.webp")})`,
//             backgroundSize: "cover",
//             backgroundPosition: "center",
//           }}
//         ></div>

//         <div className="container int-container position-relative" style={{ zIndex: 2 }}>
//           <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
//             <span className="int-badge text-white fw-semibold px-4 py-1 rounded-4">
//               Internship Programs
//             </span>
//           </div>

//           <h1 className="int-hero-title text-white text-center fw-bold mb-3">
//             Turn Knowledge Into<br />
//             <em className="text-red">Real Industry Experience</em>
//           </h1>

//           <p className="int-hero-sub text-white text-center mx-auto">
//             Gain practical skills through live projects in Industrial Automation and Digital Marketing.
//           </p>
//         </div>
//       </section>

//       {/* INTRODUCTION */}
//       <section className="py-5 int-section-gap">
//         <div className="container int-container">
//           <div className="int-honest-box border-start border-4 border-red bg-light-subtle p-4 rounded-2">
//             <p className="fw-bold text-uppercase mb-2 int-label">Why Internship at Skimitar?</p>
//             <p className="int-text">
//               Our internship programs are designed to bridge the gap between academic learning and real-world industry requirements.
//               Work on live projects, use professional tools, and get mentorship from experienced engineers and marketers.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* INDUSTRIAL AUTOMATION INTERNSHIP */}
//       <section className="py-5 bg_color int-section-gap" ref={automationRef}>
//         <div className="container int-container">
//           <div className="row g-5 align-items-center">
//             <div className="col-lg-7">
//               <h2 className="int-section-title fw-bold text-uppercase mb-4">
//                 Industrial Automation Internship Program
//               </h2>

//               <div className="d-flex flex-column gap-4">
//                 {[
//                   "PLC Programming: Design, implement and debug real PLC programs using Siemens, Allen Bradley and more.",
//                   "SCADA Development: Build real-time monitoring and control systems with industry-standard SCADA software.",
//                   "HMI Interface Design: Create user-friendly and intuitive operator interfaces.",
//                   "Embedded Systems & Microcontrollers: Work with ARM Cortex and real hardware.",
//                   "VFD Programming & Commissioning: Configure and optimize Variable Frequency Drives.",
//                   "Live Project Exposure: Apply your skills on actual industrial automation projects.",
//                   "Industry Mentorship: Learn directly from experienced automation engineers.",
//                   "Certificate of Completion: Recognized certification to boost your resume."
//                 ].map((item, i) => (
//                   <div key={i} className="d-flex gap-3">
//                     <div className="int-icon">
//                       <IoIosArrowForward />
//                     </div>
//                     <p className="int-text">{item}</p>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <div className="col-lg-5 text-center">
//               <img
//                 src={require("../../assets/images/Internship/automation.webp")}
//                 alt="Industrial Automation Internship"
//                 className="img-fluid rounded-3 shadow int-section-img"
//               />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* DIGITAL MARKETING INTERNSHIP */}
//       <section className="py-5 int-section-gap" ref={digitalRef}>
//         <div className="container int-container">
//           <div className="row g-5 align-items-center">
//             <div className="col-lg-5 text-center">
//               <img
//                 src={require("../../assets/images/Internship/Digital Marketing.webp")}
//                 alt="Digital Marketing Internship"
//                 className="img-fluid rounded-3 shadow int-section-img"
//               />
//             </div>

//             <div className="col-lg-7">
//               <h2 className="int-section-title fw-bold text-uppercase mb-4">
//                 Digital Marketing Internship Program
//               </h2>

//               <p className="int-text mb-4">
//                 Get hands-on experience in the dynamic world of digital marketing. Work on live campaigns, learn industry tools, and build a strong portfolio.
//               </p>

//               <div className="d-flex flex-column gap-4">
//                 {[
//                   "SEO Techniques: Keyword research, on-page & off-page optimization.",
//                   "Social Media Marketing: Create and manage campaigns across Meta, Instagram, LinkedIn & more.",
//                   "Google Ads & Performance Marketing: Run paid campaigns and track ROI.",
//                   "Content Strategy & Creation: Learn to write SEO-friendly content and manage blogs.",
//                   "Analytics & Reporting: Use Google Analytics, Facebook Pixel and other tools.",
//                   "Live Projects: Work on real client campaigns and see immediate results.",
//                   "Professional Certification: Get recognized certificate upon successful completion."
//                 ].map((item, i) => (
//                   <div key={i} className="d-flex gap-3">
//                     <div className="int-icon">
//                       <BiSolidChevronsRight />
//                     </div>
//                     <p className="int-text">{item}</p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* CTA */}
//       <section style={{ marginTop: '100px' }}>
//         <div className="p-5" style={{ background: '#cc0000' }}>
//           <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
//             <div className="bg-light" style={{ width: '40px', height: '1px' }} />
//             <span className="text-uppercase fw-semibold text-white text-opacity-75" style={{ letterSpacing: "2px", whiteSpace: "nowrap", fontSize: "13px" }}>
//               Start Your Automation Career
//             </span>
//             <div className="bg-light" style={{ width: '40px', height: '1px' }} />
//           </div>
//           <div className="row g-4 align-items-center">
//             <div className="col-lg-7 text-center text-lg-start">
//               <h2 className="fw-bolder text-white text-uppercase mb-3">
//                 Your Automation Career Starts at <br />
//                 "Skimitar Hindusthan"
//               </h2>
//               <p className="text-white text-opacity-75 mb-0" style={{ lineHeight: "1.75" }}>
//                 Join thousands of students who chose structured automation training, built real hands-on
//                 skills, and launched successful careers — with <b>Skimitar Hindusthan's</b> practical,
//                 industry-aligned programs and dedicated placement support at every step.
//               </p>
//             </div>
//             <div className="col-lg-5">
//               <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
//                 <button className="btn oc-btn-white px-4 py-3 fw-bold text-uppercase">
//                   Explore All Courses →
//                 </button>
//                 <button className="btn oc-btn-ghost px-4 py-3 fw-bold text-uppercase">
//                   📞 (+91) 8428010909
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// }

// export default Internship;




import React, { useRef, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import data from "../ApiUrl/meta_api.js";
import "../../assets/css/Internship.css";

import { IoIosArrowForward } from "react-icons/io";
import { BiSolidChevronsRight } from "react-icons/bi";
import { RiArrowRightWideLine } from "react-icons/ri";
import what_learn from '../../assets/img/internship-img.jpg'

// ─── Scroll Reveal Hook ─────────────────────────────────
function useScrollReveal(ref) {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(40px)';

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.style.transition = 'all 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
}

function Internship() {
  const [meta, setMeta] = useState(null);

  const heroRef = useRef(null);
  const automationRef = useRef(null);
  const digitalRef = useRef(null);
  const toolsRef = useRef(null);

  useEffect(() => {
    const internshipMeta = data[0]?.Internship_page;
    if (internshipMeta) setMeta(internshipMeta);
  }, []);

  useScrollReveal(heroRef);
  useScrollReveal(automationRef);
  useScrollReveal(digitalRef);
  useScrollReveal(toolsRef);

  const toolstechnologies = [
    {
      id: 1,
      name: "Industrial Automation",
      syllabus: [
        "Siemens PLC Programming",
        "Allen Bradley PLC",
        "Schneider Electric Systems",
        "SCADA Software (Wonderware / Ignition)",
        "HMI Design Tools",
        "VFD Drives & Commissioning",
      ],
    },
    {
      id: 2,
      name: "Embedded Systems & IoT",
      syllabus: [
        "Arduino & ESP32 Development",
        "ARM Cortex Microcontrollers",
        "MQTT & IoT Protocols",
        "Sensor Integration",
        "Edge Computing",
      ],
    },
    {
      id: 3,
      name: "Digital Marketing",
      syllabus: [
        "Google Ads & Performance Marketing",
        "Meta Ads (Facebook & Instagram)",
        "SEO & Keyword Research",
        "Google Analytics 4",
        "Content Strategy & Creation",
      ],
    },
    {
      id: 4,
      name: "IT & Software Development",
      syllabus: [
        "Python & Django",
        "Java & Spring Boot",
        "React & Node.js",
        "AWS Cloud Services",
        "Docker & Kubernetes",
        "Git & GitHub",
      ],
    },
  ];


  const whatlearn = [
    { id: 1, content: 'Work on live industrial and real-time projects' },
    { id: 2, content: 'Develop PLC programs and automation logic' },
    { id: 3, content: 'Build SCADA dashboards and monitoring systems' },
    { id: 4, content: 'Design HMI interfaces for machine control' },
    { id: 5, content: 'Learn embedded systems and IoT integration' },
    { id: 6, content: 'Execute real digital marketing campaigns' },
    { id: 7, content: 'Analyze performance using industry tools' },
    { id: 8, content: 'Gain experience under expert mentorship' },
  ]

  const outcome = [
    { icon: '⚙️', outcomename: 'Industrial Automation Engineer', content: 'Real-time PLC, SCADA, sensors & control systems la hands-on experience kidaikkum; theory ah practical ah convert panna best opportunity.' },
    { icon: '💻', outcomename: 'PLC Programmer', content: 'PLC logic (ladder diagram) write pannradhu, troubleshoot pannradhu, machines ah automate panna coding practice kidaikkum.' },
    { icon: '📊', outcomename: 'SCADA Engineer', content: 'SCADA software use panni industrial data monitoring, visualization (screens, dashboards) create panna kathukalam.' },
    { icon: '🔌', outcomename: 'Embedded Systems Developer', content: 'Microcontroller (Arduino, etc.) use panni hardware + software integrate pannradhu, small devices build pannradhu.' },
    { icon: '🌐', outcomename: 'IoT Engineer', content: 'Sensors la irundhu data collect panni internet moolama connect pannradhu (smart systems) develop panna experience kidaikkum.' },
    { icon: '📢', outcomename: 'Digital Marketing Executive', content: 'Social media, ads, campaigns handle pannitu brand reach & engagement increase panna practical knowledge kidaikkum.' },
  ]

  function SectionHeader({ label, title, subtitle, sub }) {
    return (
      <div className="mb-5">
        <span className="fw-semibold d-flex" style={{ fontSize: '20px', color: '#cc0000' }}>{label}</span>
        <h2 className="mt-2 mb-0 d-flex" style={{ lineHeight: 1.25 }}>
          <span className="oc-title-main">{title}</span>
          {subtitle && <span className="text-dark" style={{ fontSize: '15px' }}> {subtitle}</span>}
        </h2>
        {sub && <p className="mt-3 mb-0 ">{sub}</p>}
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Industrial Automation & Digital Marketing Internship in Salem | Skimitar Hindusthan</title>
        <meta name="description" content="Gain real industry experience with hands-on internships in Industrial Automation (PLC, SCADA, HMI) and Digital Marketing (SEO, Google Ads, Social Media) at Skimitar Hindusthan, Salem." />
        <link rel="canonical" href="https://skimitaracademy.com/internship" />
      </Helmet>

      {/* HERO */}
      <section className="int-hero position-relative overflow-hidden" ref={heroRef}>
        <div
          className="int-hero-bg position-absolute w-100 h-100"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.65), rgba(0,0,0,0.75)), url(${require("../../assets/images/Internship/Internship.webp")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        <div className="container int-container position-relative" style={{ zIndex: 2 }}>
          <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
            <span className="int-badge text-white fw-semibold px-4 py-1 rounded-4">
              INTERNSHIP PROGRAMS 2025-26
            </span>
          </div>

          <h1 className="int-hero-title text-white text-center fw-bold mb-3">
            Turn Knowledge Into<br />
            <em className="text-red">Real Industry Experience</em>
          </h1>

          <p className="int-hero-sub text-white text-center mx-auto">
            Hands-on internships in Industrial Automation and Digital Marketing.
            Work on live projects, use professional tools, and build a strong portfolio.
          </p>
        </div>
      </section>

      {/* INTRODUCTION */}
      <section className="py-5 int-section-gap">
        <div className="container int-container">
          <div className="int-honest-box border-start border-4 border-red bg-light-subtle p-4 rounded-2">
            <p className="fw-bold text-uppercase mb-2 int-label">Why Internship at Skimitar?</p>
            <p className="int-text">
              Our internship programs are designed to bridge the gap between academic learning and real-world industry requirements.
              Work on live projects, use professional tools, and get mentorship from experienced engineers and marketers.
            </p>
          </div>
        </div>
      </section>

      {/* INDUSTRIAL AUTOMATION INTERNSHIP */}
      <section className="py-5 bg_color int-section-gap" ref={automationRef}>
        <div className="container int-container">
          <SectionHeader
            label='Internship Program'
            title=' INDUSTRIAL AUTOMATION PROGRAM'
          />
          <div className="row g-5 align-items-center">
            <div className="col-lg-7">
              {/* <h2 className="int-section-title fw-bold text-uppercase mb-4">
                Industrial Automation Internship Program
              </h2> */}

              <div className="d-flex flex-column gap-4">
                {[
                  "PLC Programming: Design, implement and debug real PLC programs using Siemens, Allen Bradley, Mitsubishi and more.",
                  "SCADA Development: Build real-time monitoring and control systems with industry-standard SCADA software.",
                  "HMI Interface Design: Create user-friendly and intuitive operator interfaces.",
                  "Embedded Systems & Microcontrollers: Work with ARM Cortex and real industrial hardware.",
                  "VFD Programming & Commissioning: Configure and optimize Variable Frequency Drives.",
                  "Live Project Exposure: Apply your skills on actual industrial automation projects.",
                  "Industry Mentorship: Learn directly from experienced automation engineers.",
                  "Certificate of Completion: Recognized certification to boost your resume."
                ].map((item, i) => (
                  <div key={i} className="d-flex gap-3">
                    <div
                      className="d-flex justify-content-center align-items-center me-2 text-white"
                      style={{
                        backgroundColor: '#cc1919',
                        width: '30px',
                        height: '30px',
                        borderRadius: '50%',
                        flexShrink: 0
                      }}
                    >
                      <IoIosArrowForward />
                    </div>
                    <p className="int-text">{item}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-5 text-center">
              <img
                src={require("../../assets/images/Internship/automation.webp")}
                alt="Industrial Automation Internship Salem"
                className="img-fluid rounded-3 shadow int-section-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* WHAT YOU WILL DO */}
      <section className="container py-5 int-section-gap">
        <div className="">
          <SectionHeader
            label='WHAT YOU WILL DO'
            title='What You Will Learn in Our Internship'
          />
          <div className="">
            <div className="card p-3 shadow-sm">
              <p>
                During this internship program, you will work on real-time projects and gain practical exposure to industry-level tools and technologies. Unlike traditional classroom learning, this program focuses on hands-on training and problem-solving.
              </p>
            </div>
            <div className="row align-items-center mt-4">
              {/* LEFT - CONTENT */}
              <div className="col-12 col-lg-6">
                {whatlearn.map((item, index) => (
                  <div key={index} className="d-flex align-items-start my-3">

                    <span
                      className="d-flex justify-content-center align-items-center me-2 text-white"
                      style={{
                        backgroundColor: '#cc1919',
                        width: '30px',
                        height: '30px',
                        borderRadius: '50%',
                        flexShrink: 0
                      }}
                    >
                      <RiArrowRightWideLine style={{ fontSize: '20px' }} />
                    </span>

                    <p className="mb-0 ms-2">{item.content}</p>

                  </div>
                ))}
              </div>
              {/* RIGHT - IMAGE */}
              <div className="col-12 col-lg-6 text-center mt-4 mt-lg-0">
                <img
                  src={what_learn}
                  className="img-fluid rounded-4"
                  style={{ maxHeight: '420px', objectFit: 'cover' }}
                  alt="What you will learn"
                />
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* DIGITAL MARKETING INTERNSHIP */}
      <section className="py-5 int-section-gap" style={{ background: '#b1bdc938' }} ref={digitalRef}>
        <div className="container int-container">

          <div className="row g-5 align-items-center">
            <div className="col-lg-5 text-center">
              <img
                src={require("../../assets/images/Internship/Digital Marketing.webp")}
                alt="Digital Marketing Internship Salem"
                className="img-fluid rounded-3 shadow int-section-img"
              />
            </div>

            <div className="col-lg-7">
              <SectionHeader
                label='DIGITAL MARKETING INTERNSHIP'
                title='What You Will Learn in Digital Marketing Internship'
              />

              <p className="int-text mb-4">
                Get practical, hands-on experience in the fast-growing field of digital marketing.
                Work on live client campaigns, learn industry tools, and build a strong portfolio.
              </p>

              <div className="d-flex flex-column gap-4">
                {[
                  "SEO Techniques: Keyword research, on-page & off-page optimization.",
                  "Social Media Marketing: Create and manage campaigns across Meta, Instagram, LinkedIn & more.",
                  "Google Ads & Performance Marketing: Run paid campaigns and track ROI.",
                  "Content Strategy & Creation: Learn to write SEO-friendly content and manage blogs.",
                  "Analytics & Reporting: Use Google Analytics, Facebook Pixel and other tools.",
                  "Live Projects: Work on real client campaigns and see immediate results.",
                  "Professional Certification: Get recognized certificate upon successful completion."
                ].map((item, i) => (
                  <div key={i} className="d-flex gap-3">
                    <div
                      className="d-flex justify-content-center align-items-center me-2 text-white"
                      style={{
                        backgroundColor: '#cc1919',
                        width: '30px',
                        height: '30px',
                        borderRadius: '50%',
                        flexShrink: 0
                      }}
                    >
                      <BiSolidChevronsRight />
                    </div>
                    <p className="int-text">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TOOLS & TECHNOLOGIES - FAQ Style Accordion */}
      <section className="py-5 int-section-gap" ref={toolsRef}>
        <div className="container int-container">
          <div className="mb-5 text-center">
            <SectionHeader
              label='TOOLS & TECHNOLOGIES'
              title='Tools & Technologies You Will Master'
              sub='Our internship program is designed around the latest tools and technologies used in real industries.'
            />
          </div>

          <div className="accordion int-accordion" id="toolsAccordion">
            {toolstechnologies.map((tool, index) => (
              <div className="accordion-item border-0 shadow-sm mb-3 rounded-3" key={index}>
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button fw-semibold ${index !== 0 ? 'collapsed' : ''}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#toolsCollapse${index}`}
                  >
                    {tool.name}
                  </button>
                </h2>
                <div
                  id={`toolsCollapse${index}`}
                  className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                  data-bs-parent="#toolsAccordion"
                >
                  <div className="accordion-body">
                    <ul className="list-unstyled ps-0">
                      {tool.syllabus.map((syllabusItem, i) => (
                        <li key={i} className="d-flex align-items-start gap-2 mb-2">
                          <span className="int-icon" style={{ width: '20px', height: '20px', fontSize: '13px' }}
                          >
                            <IoIosArrowForward />
                          </span>
                          <span className="int-text">{syllabusItem}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Out comes */}
      <section className="py-5 int-section-gap" ref={toolsRef}>
        <div className="container int-container">
          <div className="mb-5 text-center">
            <SectionHeader
              label='CAREER OUTCOMES'
              title='Career Opportunities After Internship'
              sub='After completing this internship, you will be ready to apply for high-demand roles in multiple industries.'
            />
          </div>

          <div className="">
            <div className="row g-4"> {/* 👉 gap between cards */}

              {outcome.map((item, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4">

                  <div className="card p-3 h-100 text-center"> {/* 👉 center content */}

                    {/* ICON */}
                    <div className="d-flex justify-content-center align-items-center mb-2">
                      <span style={{ fontSize: '28px' }}>
                        {item.icon}
                      </span>
                    </div>

                    {/* TITLE */}
                    <p className="fw-semibold mb-1">
                      {item.outcomename}
                    </p>

                    {/* CONTENT */}
                    <div className="content">
                      <p className="mb-0">
                        {item.content}
                      </p>
                    </div>

                  </div>

                </div>
              ))}

            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      {/* <section style={{ marginTop: '100px' }}>
        <div className="p-5" style={{ background: '#cc0000' }}>
          <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
            <div className="bg-light" style={{ width: '40px', height: '1px' }} />
            <span className="text-uppercase fw-semibold text-white text-opacity-75" style={{ letterSpacing: "2px", whiteSpace: "nowrap", fontSize: "13px" }}>
              Start Your Automation Career
            </span>
            <div className="bg-light" style={{ width: '40px', height: '1px' }} />
          </div>
          <div className="row g-4 align-items-center">
            <div className="col-lg-7 text-center text-lg-start">
              <h2 className="fw-bolder text-white text-uppercase mb-3">
                Your Automation Career Starts at <br />
                "Skimitar Hindusthan"
              </h2>
              <p className="text-white text-opacity-75 mb-0" style={{ lineHeight: "1.75" }}>
                Join thousands of students who chose structured automation training, built real hands-on
                skills, and launched successful careers — with <b>Skimitar Hindusthan's</b> practical,
                industry-aligned programs and dedicated placement support at every step.
              </p>
            </div>
            <div className="col-lg-5">
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-end">
                <button className="btn oc-btn-white px-4 py-3 fw-bold text-uppercase">
                  Explore All Courses →
                </button>
                <button className="btn oc-btn-ghost px-4 py-3 fw-bold text-uppercase">
                  📞 (+91) 8428010909
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}

export default Internship;